export default __webpack_public_path__ + "static/media/ozqfe-min.06ed1779.png";